import React from "react";
import styles from "./NotFound.local.scss";
import _ from "i18n";

const NotFound = () => (
  <div className={styles["not-found"]}>
    <h2>{_("Nothing Found")}...</h2>
  </div>
);
export default NotFound;



// WEBPACK FOOTER //
// ./src/components/Common/NotFound/index.js